import React from 'react';
import { Shield, RefreshCw, Trash2, LogOut, Activity, Monitor, AlertTriangle } from 'lucide-react';

const AdminHeader = ({
  liveData,
  analyticsEnabled,
  isTogglingAnalytics,
  toggleAnalytics,
  allowDevTracking,
  isTogglingAllowDev,
  toggleAllowDevTracking,
  settingsUpdatedAt,
  isRefreshing,
  fetchData,
  handleResetAllData,
  onLogout,
  formatDate
}) => {
  return (
    <header className="admin-cyber-header">
      <div className="header-brand-box">
        <div className="brand-icon-wrapper">
          <Shield className="brand-shield-icon" />
        </div>
        <div className="brand-info">
          <h1 className="brand-title">PORTFOLIO CONTROL CENTER</h1>
          <div className="brand-sub-bar">
            <span className="live-status-badge">
              <span className="pulse-dot"></span>
              {liveData.liveCount || 0} ACTIVE NOW
            </span>
            {settingsUpdatedAt && (
              <span className="last-updated-text">
                Updated: {formatDate(settingsUpdatedAt)}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="header-actions-box">
        {/* Toggle Tracking Badge */}
        <button
          className={`toggle-pill-btn ${analyticsEnabled ? 'enabled' : 'disabled'}`}
          onClick={toggleAnalytics}
          disabled={isTogglingAnalytics}
          title="Toggle Global Telemetry Tracking"
        >
          <Activity className="pill-icon" />
          <span>TRACKING: {analyticsEnabled ? 'ENABLED' : 'DISABLED'}</span>
        </button>

        {/* Toggle Local Dev Tracking */}
        <button
          className={`toggle-pill-btn ${allowDevTracking ? 'enabled' : 'disabled'}`}
          onClick={toggleAllowDevTracking}
          disabled={isTogglingAllowDev}
          title="Toggle Localhost Development Telemetry Tracking"
        >
          <Monitor className="pill-icon" />
          <span>DEV TRACKING: {allowDevTracking ? 'ON' : 'OFF'}</span>
        </button>

        {/* Refresh Data */}
        <button
          className="admin-action-btn refresh-btn"
          onClick={() => fetchData({ manual: true })}
          disabled={isRefreshing}
        >
          <RefreshCw className={`btn-icon ${isRefreshing ? 'spin' : ''}`} />
          <span>{isRefreshing ? 'REFRESHING...' : 'REFRESH'}</span>
        </button>

        {/* Reset Data */}
        <button
          className="admin-action-btn danger-btn"
          onClick={handleResetAllData}
          title="Reset All Analytics Data"
        >
          <Trash2 className="btn-icon" />
          <span>RESET ALL</span>
        </button>

        {/* Logout */}
        <button
          className="admin-action-btn logout-btn"
          onClick={onLogout}
          title="Terminate Admin Session"
        >
          <LogOut className="btn-icon" />
          <span>LOGOUT</span>
        </button>
      </div>
    </header>
  );
};

export default AdminHeader;
